import { socket } from '@/socket'; //  getLobbyId,
import { toggleFullscreen } from '@/util/fullscreen';

import ActionButton from './ActionButton';

const NavCluster = () => {
	function navHome() {
		// clear socket connection here
		socket.emit('leave-all-rooms');
		window.location.href = '/';
	}

	return (
		<div className="butt-nav">
			<ActionButton
				leftEmoji="🏠"
				leftText="Home"
				onClickFunc={() => {
					navHome();
				}}
			/>

			<ActionButton
				leftEmoji="↕️"
				leftText="Zoom"
				onClickFunc={() => {
					toggleFullscreen();
				}}
			/>
		</div>
	);
};

export default NavCluster;
